export const initTrustedShops = function () {
    let tsRating = getRatingFromStorage(window.locale);

    if (tsRating === null) {
        loadRating(window.locale, 'trustedshops');
        return;
    }

    showTSBanner(tsRating);
}

document.addEventListener('DOMContentLoaded', () => {
    initTrustedShops();
});

window.initTrustedShops = initTrustedShops;

let getRatingFromStorage = function (language) {
    try {
        let data = window.sessionStorage?.getItem(getStorageKey(language));
        if (typeof data != 'undefined' && data !== null) {
            return JSON.parse(data);
        }
    } catch {}
    return null;
}

let saveRatingIntoStorage = function (language, tsRating) {
    try {
        window.sessionStorage?.setItem(getStorageKey(language), JSON.stringify(tsRating));
    } catch {}
}

let getStorageKey = function (language) {
    return 'ts_rating_' + language;
}

let loadRating = function (locale, source) {
    axios.get('//' + window.location.host + '/api/shop-ratings/' + source + '/' + locale)
        .then(({data}) => {
            if (data !== null && Object.entries(data).length > 0) {
                saveRatingIntoStorage(locale, data);
                showTSBanner(data);
            } else {
                hideTSBanner();
            }
        })
        .catch(() => hideTSBanner());
}

let hideTSBanner = function () {
    const banners = document.getElementsByClassName('ts_banner');
    for (let banner of banners) {
        banner.style.display = 'none';
    }
}

let showTSBanner = function (tsRating) {
    const labels = document.getElementsByClassName('ts_banner_label');
    const ratings = document.getElementsByClassName('ts_banner_rating');
    const banners = document.getElementsByClassName('ts_banner');

    if (banners.length === 0) {
        return;
    }

    for (let label of labels) {
        label.innerHTML = tsRating.rating_translation;
    }

    for (let rating of ratings) {
        rating.innerHTML = tsRating.rating;
    }

    for (let banner of banners) {
        banner.style.display = 'block';
    }
}
